import { render } from "./personalData.vue?vue&type=template&id=34ee9686&scoped=true"
import script from "./personalData.vue?vue&type=script&lang=js"
export * from "./personalData.vue?vue&type=script&lang=js"

import "./personalData.vue?vue&type=style&index=0&id=34ee9686&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ee9686"]])

export default __exports__